"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugState = exports.debug = exports.enableDebug = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var format_1 = require("../../shared/utils/format");
var enabled = false;
var enableDebug = function (enable) {
    enabled = enable;
};
exports.enableDebug = enableDebug;
var debug = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return enabled && console.log.apply(console, args);
};
exports.debug = debug;
var debugState = function (msg, data) {
    var transform = function (data) {
        return Object.keys(data).reduce(function (acc, key) {
            var _a;
            var value = data[key];
            if (value instanceof bn_js_1.default) {
                value = key !== "rate" ? (0, format_1.toEth)(value) : value.toNumber();
            }
            return __assign(__assign({}, acc), (_a = {}, _a[key] = value, _a));
        }, {});
    };
    var transformedData = Array.isArray(data)
        ? data.map(transform)
        : transform(data);
    enabled && console.log(msg, transformedData);
};
exports.debugState = debugState;
